import React, { useEffect, useState } from "react";
import PasswordStrengthBar from "react-password-strength-bar";
import openEye from "../../assets/svg/open-eye.svg";
import { resetPassword } from "../../service/api.service";
import "./login.css";

const ResetPassword = ({ handleResetPasswordSuccess }) => {
  const [password, setPassword] = useState("");
  const [rewritePassword, setRewritePassword] = useState("");
  const [passwordType, setPasswordType] = useState(false);
  const [rewritePasswordType, setRewritePasswordType] = useState(false);
  const [strengthAlert, setPasswordStrengthAlert] = useState(false);
  const [passwordLengthAlert, setPasswordLengthAlert] = useState(false);
  const [correctPasswordAlert, setCorrectPasswordAlert] = useState(false);
  const [_token, setToken] = useState();
  const handleResetPassword = () => {
    let validation = true;

    if (!password || !rewritePassword) {
      validation = false;
      alert("Please fill in all fields.");
    } else if (!isStrongPassword(password)) {
      validation = false;
      alert("Please set storng password");
    } else if (password !== rewritePassword) {
      validation = false;
      alert("Both passwords do not match!");
    }
    const dataBody = {
      password: password,
      token: _token,
    };
    if (validation) {
      resetPassword(dataBody).then(
        (response) => {
          if (response.status == 204) {
            alert("Your password has been updated.");
            setCorrectPasswordAlert(true);
          } else {
            alert("Error: " + response.data.message);
          }
        }
      ).catch(
        (error) => {

        }
      )
      // if (handleResetPasswordSuccess) {
      //   handleResetPasswordSuccess();
      // }
    }
  };

  const isStrongPassword = (password) => {
    const lengthRequirement = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

    return (
      lengthRequirement &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSymbol
    );
  };

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };

  const toggleRewritePassword = () => {
    setRewritePasswordType(!rewritePasswordType);
  };
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    setToken(token);
    if (!token) {
      alert("Invalid token.");
    }
  }, []);
  return (
    <div className="reset-password-page">
      <h3>RESET PASSWORD</h3>
      <div className="form">
        <p>Please enter your new password.</p>
        <div className="input-group">
          <input
            value={password}
            type={passwordType ? "text" : "password"}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordStrengthAlert(false);
              setPasswordLengthAlert(false);
            }}
            placeholder="Password"
            className="password-input"
          />
          <button onClick={togglePassword} className="toggle-button">
            <img src={openEye} alt="toggle visibility" />
          </button>
        </div>

        {passwordLengthAlert && (
          <p className="error-text">Password must be at least 8 characters long.</p>
        )}
        {strengthAlert && password && (
          <p className="error-text">
            Your password should include a combination of uppercase letters, lowercase letters, numbers, and symbols.
          </p>
        )}
        <PasswordStrengthBar password={password} />

        <div className="input-group">
          <input
            value={rewritePassword}
            type={rewritePasswordType ? "text" : "password"}
            onChange={(e) => {
              setRewritePassword(e.target.value);
              setCorrectPasswordAlert(false);
            }}
            placeholder="Rewrite Password"
            className="password-input"
          />
          <button onClick={toggleRewritePassword} className="toggle-button">
            <img src={openEye} alt="toggle visibility" />
          </button>
        </div>

        <button className="submit-button" onClick={handleResetPassword}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
